/**
 * Collection Expose carousel: recalculate Swiper layout when the split grid resizes.
 */
(function () {
  const HOST_SELECTOR = '.collection-expose__swiper-host';
  const DESKTOP_MQ = window.matchMedia('(min-width: 1200px)');

  function mountNavigationOnHost(host) {
    const sliderContainer = host.querySelector('[data-swiper-slideshow]');
    if (!sliderContainer) return;

    const navInSlider = sliderContainer.querySelector(
      '.swiper-slideshow__navigation'
    );
    const hostNavs = [...host.querySelectorAll(':scope > .swiper-slideshow__navigation')];

    if (navInSlider) {
      hostNavs.forEach(nav => {
        if (nav !== navInSlider) nav.remove();
      });

      if (navInSlider.parentElement !== host) {
        host.appendChild(navInSlider);
      }
      return;
    }

    if (hostNavs.length > 1) {
      hostNavs.slice(1).forEach(nav => nav.remove());
    }
  }

  function refreshExposeSwiper(host) {
    if (!host || host.offsetParent === null) return;

    if (typeof host.refreshLayout === 'function') {
      host.refreshLayout();
      mountNavigationOnHost(host);
      return;
    }

    const swiper = host.getSwiper?.();
    if (!swiper) return;

    const sliderContainer = host.querySelector('[data-swiper-slideshow]');
    if (sliderContainer) {
      sliderContainer.style.height = '';
      sliderContainer.classList.remove('swiper-autoheight');
      const wrapper = sliderContainer.querySelector('.swiper-wrapper');
      if (wrapper) wrapper.style.height = '';
    }

    const activeIndex = swiper.activeIndex;
    if (typeof swiper.setBreakpoint === 'function') {
      swiper.setBreakpoint();
    }
    if (typeof swiper.updateSize === 'function') {
      swiper.updateSize();
    }
    if (typeof swiper.updateSlides === 'function') {
      swiper.updateSlides();
    }
    swiper.update();
    swiper.slideTo(activeIndex, 0, false);
    mountNavigationOnHost(host);
  }

  async function reinitializeExposeSwiper(host) {
    if (!host || host.offsetParent === null) return;

    if (typeof host.reinitialize === 'function') {
      await host.reinitialize();
      mountNavigationOnHost(host);
      return;
    }

    refreshExposeSwiper(host);
  }

  function bindExposeSwiperHost(host) {
    if (host.dataset.exposeSwiperBound === 'true') return;
    host.dataset.exposeSwiperBound = 'true';

    let resizeTimer;
    const scheduleRefresh = () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        refreshExposeSwiper(host);
      }, 150);
    };

    const waitForSwiper = (attempts = 0) => {
      const swiper = host.getSwiper?.();
      if (swiper) {
        mountNavigationOnHost(host);
        refreshExposeSwiper(host);
        return;
      }

      mountNavigationOnHost(host);

      if (attempts < 40) {
        window.setTimeout(() => waitForSwiper(attempts + 1), 50);
      }
    };

    waitForSwiper();

    window.addEventListener('resize', scheduleRefresh);
    DESKTOP_MQ.addEventListener('change', () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          reinitializeExposeSwiper(host);
        });
      });
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observeTargets = [
        host.closest('.collection-expose__products'),
        host.closest('.collection-expose__split'),
        host.closest('.collection-expose__container'),
      ].filter(Boolean);

      const observer = new ResizeObserver(scheduleRefresh);
      observeTargets.forEach(target => observer.observe(target));
    }
  }

  function initCollectionExposeSwipers(root = document) {
    root.querySelectorAll(HOST_SELECTOR).forEach(bindExposeSwiperHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      initCollectionExposeSwipers()
    );
  } else {
    initCollectionExposeSwipers();
  }

  document.addEventListener('shopify:section:load', event => {
    initCollectionExposeSwipers(event.target);
  });
})();
